export default "__VITE_ASSET__Njpd8Qbi__"